<template>
  <v-container v-if="interviewForAuditPeriod">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("user.interview.title") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-simple-table>
            <template #default>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ $t("user.interview.requirement") }}</th>
                  <th>{{ $t("user.interview.question") }}</th>
                  <th>{{ $t("user.interview.funds") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row, index) in interviewForAuditPeriod.json" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ row.name }}<br />{{ row.description }}</td>
                  <td>{{ row.question }}</td>
                  <td>{{ formatList(row.funds) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-btn color="secondary" :to="{ name: 'home' }" class="mr-4">
          {{ $t("user.interview.back") }}
        </v-btn>

        <v-btn color="primary" @click="download">
          {{ $t("user.interview.download") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { join } from "ramda";
import InterviewUserQuery from "@/gql/queries/InterviewUserQuery.gql";
import InterviewForAuditPeriodQuery from "@/gql/queries/InterviewForAuditPeriodQuery.gql";
import download from "@/utils/download";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      interviewForAuditPeriod: null,
      currentUser: null,
    };
  },

  apollo: {
    interviewForAuditPeriod: {
      query: InterviewForAuditPeriodQuery,
      variables() {
        return {
          id: this.id,
        };
      },
    },

    currentUser: {
      query: InterviewUserQuery,
    },
  },

  methods: {
    formatList(list) {
      return join(", ", list);
    },

    download() {
      download(
        `${this.currentUser.company.address.name}_${this.currentUser.currentAuditPeriod.year}.csv`,
        this.interviewForAuditPeriod.csv
      );
    },
  },
};
</script>
